import React, { useEffect } from "react";
import moment from "moment";
import Image from "antd/es/image";
import * as _ from "lodash";
import { FileOutlined } from "@ant-design/icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import Emitter from "../utils/emitter";
import http from "../utils/http";

function Chat(props) {
  const [messagesClear, setMessagesClear] = React.useState([]);
  const [messages, setMessages] = React.useState([]);
  const scrollBarRef = React.useRef();

  Emitter.on("MESSAGE_SET", (newValue) => {
    loadData([newValue]);
  });

  useEffect(() => {
    if (scrollBarRef.current) {
      if (scrollBarRef.current._container !== undefined) {
        scrollBarRef.current._container.scrollTop =
          scrollBarRef.current._container.scrollHeight;
        scrollBarRef.current.updateScroll();
      }
    }
  });

  useEffect(() => {
    props.setLoading(true);
    http
      .get(
        `${process.env.REACT_APP_API_URL}/${
          process.env.REACT_APP_TENANT
        }/historyChat/${
          props.room?.name
        }?timestamp=${new Date().getMilliseconds()}`
      )
      .then((res) => {
        if (res) {
          props.setLoading(false);
          loadData(res.data);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = (data = []) => {
    if (data.length > 0) {
      if (messagesClear.length > 0) {
        setMessagesClear(messagesClear.concat(data));
        data = messagesClear.concat(data);
      } else {
        setMessagesClear(data);
      }

      let groups = data.reduce((v, item) => {
        const date = moment(item.date).format("YYYY/MM/DD");
        if (!v[date]) {
          v[date] = [];
        }
        v[date].push(item);
        return v;
      }, {});

      let groupArrays = Object.keys(groups).map((date) => {
        return {
          date,
          data: groups[date],
        };
      });

      setMessages(_.orderBy(groupArrays, ["date"], ["asc"]));
    }
  };

  return (
    <PerfectScrollbar ref={scrollBarRef}>
      <div
        style={{
          position: "relative",
          zIndex: 1,
          flex: "1 1 0",
          order: 2,
          height: "100%",
          padding: "0 20px 0 20px",
          display: "flex",
          flexDirection: "column",
        }}
        className="chatroom"
        id="room-body"
      >
        <div style={{ flex: "1 1 auto", minHeight: 12 }} />
        {messages.length > 0
          ? messages.map((item, index) => (
              <React.Fragment key={index}>
                <div
                  style={{
                    color: window.THEMES.chatBubbleColorDate,
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.date}
                </div>
                {_.uniqBy(item.data, "id")?.length > 0
                  ? _.uniqBy(item.data, "id")?.map((v, i) => (
                      <div key={i.toString()} className="transition-background">
                        <div
                          style={{
                            background:
                              v.action_type === "IN"
                                ? window.THEMES.chatBubbleIn
                                : window.THEMES.chatBubbleOut,
                            color:
                              v.action_type === "IN"
                                ? window.THEMES.chatBubbleColorIn
                                : window.THEMES.chatBubbleColorOut,
                            padding: 10,
                            marginBottom: 10,
                            borderRadius: 10,
                            width: "fit-content",
                            wordBreak: "break-all",
                            fontSize: 12,
                            maxWidth: "70%",
                            marginRight: v.action_type === "IN" ? "auto" : "",
                            marginLeft: v.action_type === "OUT" ? "auto" : "",
                            position: "relative",
                          }}
                          className={
                            v.action_type === "IN"
                              ? "left-top"
                              : v.action_type === "OUT"
                              ? "right-top"
                              : ""
                          }
                          id={v.id}
                        >
                          <div style={{ fontSize: 10, opacity: "0.5" }}>
                            {v.name}
                          </div>
                          {v.media &&
                          v.media[0]?.mimeType?.indexOf("video") > -1 ? (
                            <div className="flex flex-column">
                              <video
                                width="100%"
                                height="auto"
                                controls
                                style={{ marginBottom: 10, marginTop: 10 }}
                                onError={(e) => {
                                  http
                                    .post(
                                      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/storage/download`,
                                      {
                                        token: v.media[0].token,
                                      }
                                    )
                                    .then((res) => {
                                      if (res) {
                                        const source =
                                          document.getElementById("video-src");
                                        source.src = res.data?.data?.url;
                                      }
                                    });
                                }}
                              >
                                <source
                                  id="video-src"
                                  src={v.media[0]?.url}
                                  type={v.media[0]?.mimeType}
                                />
                                Your browser does not support HTML5 video.
                              </video>
                              {typeof v.message === "string"
                                ? v.message
                                  ? v.message.split("\n").map((msg, key) => (
                                      <span key={key.toString()}>
                                        {msg}
                                        <br />
                                      </span>
                                    ))
                                  : ""
                                : ""}
                            </div>
                          ) : v.media &&
                            v.media[0]?.mimeType?.indexOf("image") > -1 ? (
                            <div className="flex flex-column">
                              <Image
                                src={v.media[0]?.url}
                                width={200}
                                style={{ marginBottom: 10, marginTop: 10 }}
                                onError={(e) => {
                                  http
                                    .post(
                                      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/storage/download`,
                                      {
                                        token: v.media[0].token,
                                      }
                                    )
                                    .then((res) => {
                                      if (res) {
                                        if (e && e.currentTarget) {
                                          e.currentTarget.onerror = null;
                                        }
                                        e.target.src = res.data?.data?.url;
                                      }
                                    });
                                }}
                              />
                              {typeof v.message === "string"
                                ? v.message
                                  ? v.message.split("\n").map((msg, key) => (
                                      <span key={key.toString()}>
                                        {msg}
                                        <br />
                                      </span>
                                    ))
                                  : ""
                                : ""}
                            </div>
                          ) : v.media &&
                            v.media[0]?.mimeType?.indexOf("application") >
                              -1 ? (
                            <div className="flex flex-column">
                              <div
                                style={{
                                  padding: 10,
                                  background: "rgb(0 0 0 / 7%)",
                                  marginBottom: 5,
                                  marginTop: 10,
                                  borderRadius: 5,
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  fetch(v.media[0].url).then((response) => {
                                    if (response.status === 200) {
                                      window.open(v.media[0]?.url, "_blank");
                                    } else {
                                      http
                                        .post(
                                          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/storage/download`,
                                          {
                                            token: v.media[0].token,
                                          }
                                        )
                                        .then((resp) => {
                                          if (resp) {
                                            window.open(
                                              resp.data?.data?.url,
                                              "_blank"
                                            );
                                          }
                                        });
                                    }
                                  });
                                }}
                              >
                                <FileOutlined />
                                <div
                                  className="flex flex-column"
                                  style={{ marginLeft: 5 }}
                                >
                                  <span>{v.media[0].fileName}</span>
                                </div>
                              </div>
                              {typeof v.message === "string"
                                ? v.message
                                  ? v.message.split("\n").map((msg, key) => (
                                      <span key={key.toString()}>
                                        {msg}
                                        <br />
                                      </span>
                                    ))
                                  : ""
                                : ""}
                            </div>
                          ) : v.media &&
                            v.media[0]?.mimeType?.indexOf("audio") ? (
                            <audio
                              style={{ marginTop: 10 }}
                              controls
                              onError={(e) => {
                                http
                                  .post(
                                    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/storage/download`,
                                    {
                                      token: v.media[0].token,
                                    }
                                  )
                                  .then((res) => {
                                    if (res) {
                                      const source =
                                        document.getElementById("audio-src");
                                      source.src = res.data?.data?.url;
                                    }
                                  });
                              }}
                            >
                              <source
                                id="audio-src"
                                src={v.media[0]?.url}
                                type={v.media[0]?.mimeType}
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : typeof v.message === "string" ? (
                            v.message ? (
                              v.message.split("\n").map((msg, key) => (
                                <span key={key.toString()}>
                                  {msg}
                                  <br />
                                </span>
                              ))
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}{" "}
                          <br />
                          <div className="flex align-center">
                            <span
                              style={{
                                fontSize: 10,
                                color: "#c4c4c4",
                                textAlign: "right",
                                display: "block",
                              }}
                            >
                              {moment(new Date(v.date ? v.date : "")).format(
                                "MMM DD, hh:mm A"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </React.Fragment>
            ))
          : null}
      </div>
    </PerfectScrollbar>
  );
}

export default Chat;
